import React, {Component} from 'react';
import styles from "../DatiSpecifici.module.css";
import {withTranslation} from "react-i18next";
import MalattieService from '../../../../../services/MalattieService';
import Utils from '../../../../../utils/Utils';
import SelectAutocomplete from "../../../../../components/selectAutocomplete/SelectAutocomplete";
import $ from "jquery";
import OggettiUtili from "../../../../../utils/OggettiUtili.json";
import SessioneUtente from "../../../../../sessionManager/SessioneUtente";
import Ruoli from "../../../../../utils/Ruoli";


class SedeAnatomica extends Component {

    state = {

        sedeAnatomica: {
            primaLocalizzazione: "",
            altraLocalizzazione: "",
            corretto: []
        },
        listaPrimaLocalizzazioni: [],
        listaAltreLocalizzazioni: [],

    }


    constructor(props) {
        super(props);
        this.riceviValorePrima = this.riceviValorePrima.bind(this);
        this.riceviValoreAltra = this.riceviValoreAltra.bind(this);
        this.controlloCorrettezza = this.controlloCorrettezza.bind(this)
        this.disablePicker = this.disablePicker.bind(this)

    }

    componentDidMount() {
        this.controlloCorrettezza()
        MalattieService.getPrimaLocalizzazione(this.props.malattia).then((data) => {
            let resPrima = Utils.mapToArray(data.data);
            this.setState({listaPrimaLocalizzazioni: resPrima})
        }).catch(() => {
            console.log("errore chiamata getPrimaLocalizzazione")
        });

        MalattieService.getAltraLocalizzazione(this.props.malattia).then((data) => {
            let resAltra = Utils.mapToArray(data.data);
            this.setState({listaAltreLocalizzazioni: resAltra})
        }).catch(() => {
            console.log("errore chiamata getAltraLocalizzazione")
        });

        if (this.props.segnalazioneCopia.datiSpecifici) {
            if (this.props.segnalazioneCopia.datiSpecifici.sedeAnatomica) {
                let sedeAnatomica = this.state.sedeAnatomica;
                let propsAnatomica = JSON.parse(JSON.stringify(this.props.segnalazioneCopia.datiSpecifici.sedeAnatomica));
                sedeAnatomica.altraLocalizzazione = propsAnatomica.altraLocalizzazione ? propsAnatomica.altraLocalizzazione : ""
                sedeAnatomica.primaLocalizzazione = propsAnatomica.primaLocalizzazione ? propsAnatomica.primaLocalizzazione : ""
                this.setState({sedeAnatomica: sedeAnatomica})
                this.props.setSedeAnatomica(this.state.sedeAnatomica)
                this.controlloCorrettezza()
            }
        }
        this.disablePicker()
    }

    disablePicker() {

        if (this.props.segnalazioneCopia && this.props.segnalazioneCopia.migrazione || (this.props.segnalazioneCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
            this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice)) {
            $(document).ready(function () {
                $(".selectpicker").selectpicker('disabled')
                $('.selectpicker').selectpicker('refresh')
            });
        } else {
            $(document).ready(function () {
                $(".selectpicker").selectpicker('disabled', false)
                $('.selectpicker').selectpicker('refresh')
            });
        }

    }

    controlloCorrettezza() {

        let sedeAnatomica = this.state.sedeAnatomica
        sedeAnatomica.corretto = []
        if (sedeAnatomica.primaLocalizzazione === null ||
            sedeAnatomica.primaLocalizzazione === undefined ||
            sedeAnatomica.primaLocalizzazione === "") {
            sedeAnatomica.corretto[0] = "Campo \"Prima localizzazione\" mancante"
        } else {
            sedeAnatomica.corretto[0] = ""
        }

        this.setState({sedeAnatomica: sedeAnatomica})

        let sede = Object.assign({}, this.state.sedeAnatomica)
        let sedeAnatomicaObj = Utils.removeFieldFromObject(sede, "corretto");

        this.props.setSedeAnatomica(this.state.sedeAnatomica, sedeAnatomicaObj)
    }

    riceviValorePrima(event) {
        let sedeAnatomicaNew = this.state.sedeAnatomica
        let valueNew = event.target.value
        sedeAnatomicaNew.primaLocalizzazione = valueNew
        this.setState({sedeAnatomica: sedeAnatomicaNew});
        this.props.setSedeAnatomica(this.state.sedeAnatomica)
        this.controlloCorrettezza()
        this.disablePicker()

    }

    riceviValoreAltra(event) {
        let sedeAnatomicaNew = this.state.sedeAnatomica
        let valueNew = event.target.value
        sedeAnatomicaNew.altraLocalizzazione = valueNew
        this.setState({sedeAnatomica: sedeAnatomicaNew});
        this.props.setSedeAnatomica(this.state.sedeAnatomica)
        this.controlloCorrettezza()
        this.disablePicker()
    }

    render() {
        const {t} = this.props
        return (

            <div style={{marginTop: "1rem"}} value={this.state.sedeAnatomica}>
                <h6>{t("DatiSpecifici.SedeAnatomica.titolo")}</h6>
                <hr className={styles.hr}/>
                <div className={"container"}>

                    <div className="row" style={{paddingTop: "10px"}}>
                        <p className={styles.testo}>{t("DatiSpecifici.SedeAnatomica.primaLocalizzazione")}
                            <span className={styles.mandatoryColor}>*</span></p>
                        <div className="col-lg-12">
                            <SelectAutocomplete
                                onChange={this.riceviValorePrima}
                                disabled={this.props.segnalazioneCopia.migrazione || SessioneUtente.getInstance().ruoliUtente === Ruoli.Operatore_Laboratorio.descrizione || (this.props.segnalazioneCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
                                    this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice)}
                                value={this.state.sedeAnatomica.primaLocalizzazione}
                                functionMap={this.state.listaPrimaLocalizzazioni.map((oggetto) => {
                                    return (<option
                                        value={oggetto.codicePrimaLocalizzazione}>{oggetto.descrizionePrimaLocalizzazione}</option>)
                                })}>
                            </SelectAutocomplete>

                        </div>
                    </div>
                    <div className="row" style={{paddingTop: "10px"}}>
                        <p className={styles.testo}>{t("DatiSpecifici.SedeAnatomica.altraLocalizzazione")}</p>
                        <div className="col-lg-12">
                            <SelectAutocomplete
                                onChange={this.riceviValoreAltra}
                                disabled={this.props.segnalazioneCopia.migrazione || SessioneUtente.getInstance().ruoliUtente === Ruoli.Operatore_Laboratorio.descrizione || (this.props.segnalazioneCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
                                    this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice)}
                                value={this.state.sedeAnatomica.altraLocalizzazione}
                                functionMap={this.state.listaAltreLocalizzazioni.map((oggetto) => {
                                    return (<option
                                        value={oggetto.codiceAltraLocalizzazione}>{oggetto.descrizioneAltraLocalizzazione}</option>)
                                })}>
                            </SelectAutocomplete>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}

export default withTranslation('common')(SedeAnatomica);
